"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// This is list of all our hardcoded house ads, which are used in regions
// that are currently ad disabled to reduced adzerk load. To add a new
// creative, add a new entry into the array, put the files in the assets s3
// and it should just work. all the ads are weighted equally. This list is
// used for both CSR and SSR generated ads
var adsList = [
    {
        prefix: "Fallback-Ad-Refresh-Q3-2024_Set-1",
        link: "https://w.tt/4iDCBRw",
        postfix: "",
        sizes: ["320x50", "300x250", "160x600", "300x600", "728x90"],
    },
];
/**
 * Returns a list of hardcoded ads that fit the passed in width and height
 */
function getHardcodedAdsList(width, height) {
    return adsList.filter(function (ad) {
        return ad.sizes.includes(width + "x" + height);
    });
}
exports.default = getHardcodedAdsList;
